import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useConfig } from "../../utils/useConfig";
import { useMutation } from "react-query";
import { changeUserStatus } from "../../mutations/users/changeUserStatus";
import { getSafeSessionConfig } from "../utils/getSafeSessionConfig";
import { useData } from "../../utils/useData";
import { toast } from "react-toastify";
import { Employee, EmployeeStatus } from "../../models";

export const useChangeUserStatus = (options?: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
}) => {
    const { config } = useConfig();
    const { getToken } = useKindeAuth();
    const { employerId, employees, accounts } = useData();

    return useMutation(
        async (employee: Employee) => {
            const { API_URL, token } = await getSafeSessionConfig(config, getToken);

            if (!employee) throw new Error("Employee not found");

            const newStatus = employee.status === EmployeeStatus.Active 
                ? EmployeeStatus.Inactive 
                : EmployeeStatus.Active;

            await changeUserStatus(API_URL, token, employerId, employee.id, newStatus);
        },
        {
            onSuccess: () => {
                toast.success("User Status updated successfully");
                employees.refetch();
                accounts.refetch();      
                options?.onSuccess?.();
            },
            onError: (error: Error) => {
                console.error(error.message);
                toast.error(error.message);      
                options?.onError?.(error);
            }
        }
    )
}